import { reportScopedError } from 'shared-utils/error'

import type { PublicRuntimeConfig } from 'nuxt/schema'
import type { FirebaseCoreService } from 'shared-types/firebase'

async function getFirebaseCoreService (env: PublicRuntimeConfig): Promise<FirebaseCoreService | undefined> {
  try {
    const { createFirebaseCoreService } = await import('shared-services/firebase')
    const service = await createFirebaseCoreService(env)

    window.firebase = service

    return service
  } catch (err) {
    const error = err as Error

    reportScopedError('plugins::firebase', 'Initialization failed', error)

    return undefined
  }
}

export default defineNuxtPlugin(nuxtApp => {
  if (!import.meta.client) {
    return
  }

  try {
    const config = useRuntimeConfig()

    // Deferred after hydration: firebase stays out of the entry chunk and never delays the first render.
    const firebase = new Promise<FirebaseCoreService | undefined>(resolve => {
      onNuxtReady(async () => {
        const service = await getFirebaseCoreService(config.public)

        resolve(service)
      })
    })

    nuxtApp.provide('firebase', firebase)
  } catch (err) {
    const error = err as Error

    reportScopedError('plugins::firebase', 'Initialization failed', error)
  }
})
